
import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import MainLayout from '@/components/layouts/MainLayout';
import PageHeader from '@/components/common/PageHeader';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { useAuthor } from '@/hooks/useAuthors';
import AuthorProfile from '@/components/admin/AuthorProfile';
import PaymentInformation from '@/components/admin/PaymentInformation';

const AuthorDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { data: author, isLoading } = useAuthor(id || '');

  if (isLoading) {
    return (
      <MainLayout allowedRoles={['admin']}>
        <div className="flex justify-center p-8">
          <p>Loading author details...</p>
        </div>
      </MainLayout>
    );
  }

  if (!author) {
    return (
      <MainLayout allowedRoles={['admin']}>
        <div className="flex justify-center p-8">
          <p>Author not found</p>
        </div>
      </MainLayout>
    );
  }

  return (
    <MainLayout allowedRoles={['admin']}>
      <div className="mb-4">
        <Button
          variant="ghost"
          onClick={() => navigate('/admin/authors')}
          className="mb-4"
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Back to Authors
        </Button>
      </div>
      
      <PageHeader
        title={author.name}
        description={`Author profile and details`}
      />
      
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-6">
        <div className="lg:col-span-1">
          <AuthorProfile author={author} />
        </div>
        
        <PaymentInformation author={author} />
      </div>
    </MainLayout>
  );
};

export default AuthorDetail;
